import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Auto-applies noindex,nofollow for routes that require authentication
 * or should not be crawled. Runs globally in App.tsx.
 */

const AUTH_ROUTE_PREFIXES = [
  "/profile",
  "/dashboard",
  "/coach-edit",
  "/coach-academy",
  "/academy/join",
  "/academy/apply",
  "/create-experience",
  "/create-academy",
  "/manage-academy",
  "/bookings",
  "/notifications",
  "/messages",
  "/chat",
  "/checkout",
  "/booking-success",
  "/coach-invitations",
  "/collaborate",
  "/learner-groups",
  "/groups/",
  "/create-group",
  "/skill-progression",
  "/admin/",
  "/partner/",
  "/maestro",
  "/coach-onboarding",
  "/feedback",
  "/business-card",
  "/mateo-open/sessions",
  "/mateo-stage",
  "/stage-onboarding",
  "/demo/",
  "/foundry/",
  "/gift/redeem",
  "/opt-out-analytics",
  "/auth",
];

export const CrawlerNoIndex = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const shouldNoIndex = AUTH_ROUTE_PREFIXES.some(
      (prefix) => pathname === prefix || pathname.startsWith(prefix)
    );

    let robotsMeta = document.querySelector('meta[name="robots"]');

    if (shouldNoIndex) {
      if (!robotsMeta) {
        robotsMeta = document.createElement("meta");
        robotsMeta.setAttribute("name", "robots");
        document.head.appendChild(robotsMeta);
      }
      robotsMeta.setAttribute("content", "noindex, nofollow");
    } else if (robotsMeta && !document.querySelector('[data-page-noindex]')) {
      // Only remove if PageMeta didn't explicitly set noindex
      robotsMeta.remove();
    }
  }, [pathname]);

  return null;
};
